import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

declare let moment: any;

@Pipe({
    name: 'localizedDate',
    pure: false,
})
export class LocalizedDatePipe implements PipeTransform {

    constructor(private translateService: TranslateService) {
        this.translateService.setDefaultLang("fr");
    }

    transform(value: any, withHours = false): any {
        let value2;
        let myDate;
        if(!value) {
            return null;
        }

        if(typeof value === 'string') {
            if(moment(value).isValid()) {
                myDate = moment(value);
            }
            else {
                let format = 'DD-MM-YY';
                if(withHours) {
                    format += ' HH:mm';
                }

                if(moment(value, format).isValid()) {
                    myDate = moment(value, format);
                }
                else {
                    return value;
                }
            }
            //value2 = value.format();
        }
        let format = 'DD/MM/YY';
        if(withHours) {
            format += ' HH:mm';
        }

        // const datePipe = new DatePipe(this.translateService.currentLang, 'Europe/Brussels');
        // const date = datePipe.transform(value, format);
        // return date;
        // console.log(date);
        return myDate.format(format);
    }

}
